import { forwardRef } from "react";
import { cn } from "../../lib/utils";
import { Segment } from "./Segment";

export type SegmentedBadgeStatus = "success" | "warning" | "error" | "alert" | undefined;

export interface SegmentedBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  segments: Array<{
    value: string | number;
    unit: string;
    status: SegmentedBadgeStatus;
    className?: string;
  }>;
}

export const SegmentedBadge = forwardRef<HTMLDivElement, SegmentedBadgeProps>(
  ({ className, segments, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("inline-flex items-stretch border rounded-[10px] overflow-hidden", className)}
        {...props}
      >
        {segments.map((segment) => (
          <Segment
            key={`${segment.value}-${segment.status}-${segment.unit}`}
            value={segment.value}
            unit={segment.unit}
            status={segment.status}
            className={segment.className}
          />
        ))}
      </div>
    );
  }
);
